module.exports = __webpack_public_path__ + "media/components/resources/svgs/ic_check-04f058e6d0f55c82db0456999b460f31.svg";